export default "__VITE_ASSET__IVB9cSid__"